import { keys, values, isPlainObject } from 'lodash';

/**
 * Convert object to array
 * @param dataObj object
 * @param keyField string
 * @returns {array}
 */
export const fromObjToArray = (dataObj, keyField = 'key') =>
    keys(dataObj).map(key => ({
        [keyField]: key,
        ...dataObj[key],
    }));

/**
 * Check if all obj/array values are empty
 * @param obj array
 * @returns {boolean}
 */
export const areAllFieldsEmpty = obj =>
    values(obj).every(val =>
        (isPlainObject(val) ? areAllFieldsEmpty(val) : (!val))
    );



// WEBPACK FOOTER //
// ./src/js/utils/object.js